var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FBE4E4",
    width: 60,
    height: 60,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.816 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FF5F5F",
    width: 34,
    height: 28,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFD46E",
    cx: 33.134,
    cy: 20.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.134 13c.293 0 .582.017.866.05V24a4.002 4.002 0 0 1-2.683 3.778A7.5 7.5 0 0 1 33.134 13z",
    fill: "#E20D25"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 5.977,
    y: 21.5,
    width: 9.685,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 6.5h34v2H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAccount);
export default __webpack_public_path__ + "static/media/bankAccount.d36348652d8e53336e44413c890c248d.svg";
export { ForwardRef as ReactComponent };